import React from 'react';
import { ActivityIcon, BookOpenIcon, CalendarDaysIcon, ClockIcon } from 'lucide-react';
import { differentiators } from '../data/content';
import { Mark, SectionTitle } from './ui/Section';
const icons = {
  book: BookOpenIcon,
  clock: ClockIcon,
  activity: ActivityIcon,
  calendar: CalendarDaysIcon
};
export function Differentiators() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-42" data-mp="1w5495ijrqy33">
      <div className="mx-auto max-w-5xl" data-id="element-43" data-mp="zdiq7v0zz0og">
        <SectionTitle data-id="element-44" data-mp="zetya71h6uld">
          Not just another collection of techniques. <Mark data-id="element-45" data-mp="13f42be5pjaxl">A complete professional system.</Mark>
        </SectionTitle>

        <ul className="mt-10 grid gap-x-8 gap-y-8 sm:grid-cols-2" data-id="element-46" data-mp="18cw2evgia3cv">
          {differentiators.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex gap-4" data-id="element-47" data-mp="2jskpdmtrf2do">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand" data-id="element-48" data-mp="2js2qsjjmkc2l">
                  <Icon className="h-5 w-5 text-gold-light" aria-hidden="true" data-id="element-49" data-mp="2opuh594mfq4o" />
                </span>
                <div data-id="element-50" data-mp="bmq2pcqcxs2f">
                  <h3 className="text-sm font-black uppercase leading-tight text-brand-deep" data-id="element-51" data-mp="7n8uibjjqgtk">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-snug text-slate-600" data-id="element-52" data-mp="2nvzv4mfo5gf">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}